<template>
  <section id="Footer">
    <b-container>
      <div class="footer-cnt">
        <div class="logo">
          <a href="https://www.denverbroncos.com/tickets/seasontickets/policies" target="_blank"><img src="@/assets/logo_primary.svg"></a>
        </div>
      </div>
    </b-container>
  </section>
</template>

<script>
  export default {
    name: "Footer"
  }
</script>

<style lang="scss" scoped>
  #Footer {
    position: relative;
    display: inline-flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 28px 0px;
    background-color: $white;
    .container {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 1000px;
      margin: 0 auto;
      .footer-cnt {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .logo {
          position: relative;
          display: inline-block;
          width: auto;
          a {
            img {
              width: 92px;
            }
          }
        }
        .copy {
          p {
            font-family: ProximaNova-Semibold;
            font-size: 7px;
            line-height: 18px;
            text-align: center;
            color: #FFF;
            a {
              text-transform: uppercase;
              color: #FFF;
            }
          }
        }
      }
    }
  }
</style>